import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultContactInfo,
  defaultFlatShareRoomProperties,
  getSchemaForOtherFacilitiesByIntermediateRent,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantFlatShareRoomRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpaceFlatShareRoom,
    room: validationRules.roomFlatShareRoom,
    noBathrooms: validationRules.noBathrooms,
    roomSize: validationRules.roomSize,
    price: validationRules.price,
  },
  costs: {
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    heatingCosts: validationRules.heatingCosts,
  },
  contactInfo: defaultContactInfo,
  otherFacilities: getSchemaForOtherFacilitiesByIntermediateRent,
  flatShareRoomProperties: defaultFlatShareRoomProperties,
  whoWeLookFor: {
    requestedGender: validationRules.requestedGender,
    numberOfRequestedFlatMates: validationRules.numberOfRequestedFlatMates,
    ageOfRequestedFrom: validationRules.ageOfRequestedFrom,
    ageOfRequestedTo: validationRules.ageOfRequestedTo,
    flatShareSize: validationRules.flatShareSize,
    numberOfMaleFlatMates: validationRules.numberOfMaleFlatMates,
    numberOfFemaleFlatMates: validationRules.numberOfFemaleFlatMates,
    ageOfFlatMatesFrom: validationRules.ageOfFlatMatesFrom,
    ageOfFlatMatesTo: validationRules.ageOfFlatMatesTo,
  },
}
